import CustomSegment from "../../../../components/ui/CustomSegment";
import { useSegment } from "../../../../hooks/useSegment";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { SegmentedType } from "../../../../types";
import KPIGroups from "./_components/KPIList/KPIGroups";
import KPIPerformance from "./_components/KPIList/KPIPerformance";

type SegmentType = "groups" | "performance";

const KPISetup = () => {
  const { segment, setSegment } = useSegment<SegmentType>(
    "kpi-segment",
    "groups",
  );

  const SEGMENT_CONFIG: SegmentedType<SegmentType>[] = [
    {
      key: "groups",
      label: "KPI Groups",
      element: <KPIGroups />,
    },
    {
      key: "performance",
      label: "KPI Performance",
      element: <KPIPerformance />,
    },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.key === segment);

  return (
    <SidebarLayout title="KPI Setup">
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.element}</div>
    </SidebarLayout>
  );
};

export default KPISetup;
